import React from 'react';

import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { RENT_VS_BUY } from '../../../../lib/analytics-constants';
import {
  RentVsBuyInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HOADuesInput: React.FC<RentVsBuyInput> = ({
  placeholder,
  value,
  errorMessage,
  dispatch,
  analytics,
  label = '',
  tooltip = '',
  className = '',
  fullWidth,
}) => {
  const formattedPlaceholder = num.formatCurrency(placeholder);
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'HOADues',
      calculator: RENT_VS_BUY,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      placeholder={formattedPlaceholder}
      value={String(value)}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  placeholder: state?.rentvsbuyCalculator?.inputs?.HOADues,
  value: state?.rentvsbuyCalculator?.manualInputs?.HOADues,
  errorMessage: state?.validations?.HOADues?.[0],
});

export default connect(mapStateToProps)(HOADuesInput);
